import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useParams, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Checkbox } from '@material-ui/core';
import { StyledButton, SagnificantText } from 'UIKit/Form';
import { Box, Flex } from 'UIKit/Grid';

import Panel from '@/components/Panel';
import Loading from '@/components/Form/Loading';

import {
  fetchActiveOlimpics,
  REQUEST_GET_OLIMPIC_ACTIVE,
  TYPE,
  fetchOlimpicStart,
} from '@/modules/Olimpic';
import { fetchLoadData } from '@/modules/User';
import Timer from '@/components/Timer';
import PurchaseModal from '@/components/PurchaseModal/PurchaseModal';
import RequireModal from './RequireModal';

const StyledButtonRun = styled(StyledButton)`
  background: linear-gradient(180deg, #00064aa6 0%, #00524ba6 100%) !important;
  font-weight: bold !important;
`;

const PingStatus = styled.div`
  background-color: ${({ color }) => color};
  width: 14px;
  height: 14px;
  border-radius: 100%;
  display: inline-block;
`;

const StyledHeader = styled.h3`
  color: red;
  font-size: 30px;
  font-weight: bold;
  letter-spacing: 10px;
  text-transform: uppercase;
`;

const host = process.env.BACKEND_URL;

const PreRun = ({ loadData, startOlimpic, requests, olimp }) => {
  const type = useParams().type || TYPE.ONLINE;
  const history = useHistory();

  const olimpic = olimp[type];

  const participant = olimpic?.participant;

  const [ping, setPing] = useState({ latency: 0, color: 'green' });

  const checkPing = async () => {
    const time = new Date();

    try {
      const res = await fetch(`${host}/ping`, {
        // method: 'HEAD',
        cache: 'no-cache',
      });

      const latency = new Date() - time;

      let color = 'red';

      if (res.status === 200) {
        if (latency < 5000) {
          color = 'yellow';
        }
        if (latency < 1000) {
          color = 'green';
        }
      }

      setPing({
        color,
        latency: latency / 1000,
      });
    } catch {
      setPing({
        color: 'black',
        latency: null,
      });
    }
  };

  useEffect(() => {
    loadData();
    checkPing();

    const interval = setInterval(checkPing, 5000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const request = requests[REQUEST_GET_OLIMPIC_ACTIVE];

  const [timerEnded, setTimerEnded] = useState(false);
  const [rulesCheck, setRulesCheck] = useState(false);
  const [videoCheck, setVideoCheck] = useState(false);
  const [readyCheck, setReadyCheck] = useState(false);

  const handleRunExam = async () => {
    const response = await startOlimpic(olimpic._id);

    if (response.type === 'SUCCESS') {
      history.push('/olimpic/run/exam', { pass: true });
    }
  };

  return (
    <Panel>
      <Box w={1} p={7}>
        {request && (
          <>
            {request && <>{request.loading && <Loading />}</>}
            {!olimpic && (
              <SagnificantText>
                <FormattedMessage id="OLIMPIC_NOT_FOUND" defaultMessage="" />
              </SagnificantText>
            )}
            {olimpic && participant && (
              <>
                <Flex>
                  <Box py={5}>
                    <StyledHeader>
                      <FormattedMessage
                        id="GET_READY"
                        defaultMessage="GET READY"
                      />
                      !
                    </StyledHeader>
                  </Box>
                  <Flex alignContent="center" />
                </Flex>
                <Box mb={4}>
                  <FormattedMessage
                    id="OLIMPIC_START_NOTIFY"
                    defaultMessage=" We wish you good luck and victory! After clicking the
                    “Start the Olympiad” button, you will not be able to go
                    back, you will only have 1 attempt. The entire Olympiad
                    from beginning to end must be filmed. Upload the video to
                    any cloud storage and attach a link."
                  />
                </Box>
                <Box mb={4}>
                  <FormattedMessage
                    id="OLIMPIC_TECHNICAL_REQUIREMENT"
                    defaultMessage=" "
                  />
                </Box>
                <Box mb={4}>
                  <FormattedMessage
                    id="CURRENT_PING"
                    defaultMessage="Current latency"
                  />{' '}
                  <PingStatus color={ping.color} /> {ping.latency?.toFixed(2)}{' '}
                  <FormattedMessage id="SEC" defaultMessage="sec." /> (
                  <FormattedMessage
                    id={
                      {
                        green: 'GOOD',
                        yellow: 'NORMAL',
                        black: 'DISCONNECTED',
                        red: 'WORST',
                      }[ping.color]
                    }
                    defaultMessage=" "
                  />
                  )
                </Box>
                <Box mb={4}>
                  <FormattedMessage
                    id="OLIMPIC_LINK_REQUIRED_NOTIFY"
                    defaultMessage=" A video link is required, otherwise the prize place will be
                    lowered! Make sure that access to the video is open. Attach
                    the link is also available after the Olympiad before
                    checking the results"
                  />
                </Box>
                <Box mb={4}>
                  <FormattedMessage
                    id="OLIMPIC_PRE_RUN_NOTIFY"
                    values={{ name: olimpic.name }}
                  />
                </Box>
                <Flex alignItems="center">
                  <Checkbox
                    value={rulesCheck}
                    onChange={(e, v) => setRulesCheck(v)}
                  />
                  <label>
                    <SagnificantText>
                      <FormattedMessage
                        id="IVE_READ_RULES"
                        defaultMessage="I've read the rules"
                      />
                    </SagnificantText>
                  </label>
                </Flex>
                <Flex alignItems="center">
                  <Checkbox
                    value={videoCheck}
                    onChange={(e, v) => setVideoCheck(v)}
                  />
                  <label>
                    <SagnificantText>
                      <FormattedMessage
                        id="PREPARED_CAMERA"
                        defaultMessage="I've got the camera ready"
                      />
                    </SagnificantText>
                  </label>
                </Flex>
                <Flex alignItems="center">
                  <Checkbox
                    value={readyCheck}
                    onChange={(e, v) => setReadyCheck(v)}
                  />
                  <label>
                    <SagnificantText>
                      <FormattedMessage
                        id="IM_READY"
                        defaultMessage="I'm ready"
                      />
                    </SagnificantText>
                  </label>
                </Flex>
                <Box mt={4}>
                  <StyledButtonRun
                    onClick={handleRunExam}
                    disabled={
                      !(timerEnded && readyCheck && videoCheck && rulesCheck)
                    }
                  >
                    {timerEnded ? (
                      <FormattedMessage id="OLIMPIC_RUN" defaultMessage="" />
                    ) : (
                      <Box ml={-7} mt={1}>
                        <Timer onEnd={() => setTimerEnded(true)} time={45} />
                      </Box>
                    )}
                  </StyledButtonRun>
                </Box>
              </>
            )}
          </>
        )}
      </Box>
    </Panel>
  );
};

PreRun.propTypes = {
  loadData: PropTypes.func.isRequired,
  startOlimpic: PropTypes.func.isRequired,
  olimp: PropTypes.object.isRequired,
  requests: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  requests: state.requests,
  olimp: state.olimpic,
});

const mapDispatchToProps = dispatch => ({
  loadData() {
    dispatch(fetchActiveOlimpics());
    dispatch(fetchLoadData());
  },
  startOlimpic(id) {
    return dispatch(fetchOlimpicStart(id));
  },
});

export const PreRunComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(PreRun);

const Purchased = ({ olimpic }) => {
  return (
    <PurchaseModal noDemo exclude={!olimpic?.free}>
      <RequireModal>
        <PreRunComponent />
      </RequireModal>
    </PurchaseModal>
  );
};

Purchased.propTypes = {
  olimpic: PropTypes.object.isRequired,
};

export default connect(state => ({ olimpic: state.olimpic.online }))(Purchased);
